import QuickQuoteSettings from "./quickQuoteSettings"

export default QuickQuoteSettings
